import {materialPermissions} from '../../../../utils/materialPermissions';
import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams, useLocation} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import InventoryLabelPrintDialog from "../labelprint/InventoryLabelPrintDialog";

const MaterialListComponent = (props) => {

  const {t} = props;
  const canWrite = materialPermissions().write;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const dt = useRef(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [materialGroupOptions, setMaterialGroupOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [labelPrintMaterial, setLabelPrintMaterial] = useState(null);
  const canPrintLabels = (localStorage.getItem('roles') || '')
    .toUpperCase()
    .includes('ROLE_INVENTORY_LABEL_PRINT');
  const vars = window.App.urlVars();
  const projectBacklink = vars.backlink ? decodeURIComponent(vars.backlink) : '/project';
  const rowIndex = vars.materialRowIndex;
  // const view = (window.App.urlVars().view || 'master').toLowerCase();
  // const isLocked = vars.lock_status === '1';
  const location = useLocation();
  const qs = new URLSearchParams(location.search);

  const view = (qs.get('view') || 'master').toLowerCase();
  const isLocked = qs.get('lock_status') === '1';
  
  const LIST_STORAGE_KEY = `lastMaterialListState-${view}-${isLocked ? 'locked' : 'unlocked'}`;
  const DEFAULT_SORT_FIELD = 'name';
  const DEFAULT_SORT_ORDER = 1;
  const defaultFilters = {
    name: { value: null, matchMode: 'contains' },
    status: { value: 'ACTIVE', matchMode: 'equals' },
    material_group: { value: null, matchMode: 'equals' },
    manufacturer_name: { value: null, matchMode: 'contains' },
    unit: { value: null, matchMode: 'equals' },
    upc: { value: null, matchMode: 'contains' },
    sku: { value: null, matchMode: 'contains' },
    category: { value: null, matchMode: 'equals' },
  };
  const savedListState = localStorage.getItem(LIST_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LIST_STORAGE_KEY))
    : null;
    
  const [rows, setRows] = useState(
    savedListState?.rows || Number(process.env.REACT_APP_LIST_ROW_DEFAULT)
  );
  const [lazyParams, setLazyParams] = useState(() => {
    const savedLazyParams = savedListState?.lazyParams;
    if (savedLazyParams) {
      return {
        ...savedLazyParams,
        first: savedLazyParams.first ?? 0,
        rows: savedLazyParams.rows ?? rows,
        page: savedLazyParams.page ?? 0,
        sortField: savedLazyParams.sortField || DEFAULT_SORT_FIELD,
        sortOrder: typeof savedLazyParams.sortOrder === 'number' ? savedLazyParams.sortOrder : DEFAULT_SORT_ORDER,
        filters: {
          ...defaultFilters,
          ...(savedLazyParams.filters || {})
        }
      };
    }
    return {
      first: 0,
      rows: rows,
      page: 0,
      sortField: DEFAULT_SORT_FIELD,
      sortOrder: DEFAULT_SORT_ORDER,
      filters: defaultFilters,
    };
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      const hasQuestionMark = query.startsWith('?');
      const params = new URLSearchParams(hasQuestionMark ? query.substring(1) : query);
      // const manufacturerFilter = lazyParams.filters?.manufacturer_name;
      // params.delete('search[manufacturer_name]');
      // params.delete('search[manufacturer_name][value]');
      // params.delete('search[manufacturer_name][operator]');
      // if (manufacturerFilter && manufacturerFilter.value) {
      //   params.set('search[manufacturer_name]', manufacturerFilter.value);
      // }
      applyContainsFilter(params, lazyParams?.filters, 'name');
      applyContainsFilter(params, lazyParams?.filters, 'manufacturer_name');
      applyContainsFilter(params, lazyParams?.filters, 'upc');
      applyContainsFilter(params, lazyParams?.filters, 'sku');
      const categoryFilter = lazyParams?.filters?.category;
      if (
        !categoryFilter ||
        categoryFilter.value === null ||
        categoryFilter.value === undefined ||
        categoryFilter.value === 'undefined'
      ) {
        params.delete('search[category][operator]');
        params.delete('search[category][value]');
      }
      const materialGroupFilter = lazyParams?.filters?.material_group;
      if (
        !materialGroupFilter ||
        materialGroupFilter.value === null ||
        materialGroupFilter.value === undefined ||
        materialGroupFilter.value === 'undefined'
      ) {
        params.delete('search[material_group][operator]');
        params.delete('search[material_group][value]');
      }
      const unitFilter = lazyParams?.filters?.unit;
      if (
        !unitFilter ||
        unitFilter.value === null ||
        unitFilter.value === undefined ||
        unitFilter.value === 'undefined'
      ) {
        params.delete('search[unit][operator]');
        params.delete('search[unit][value]');
      }
      const skuFilter = lazyParams?.filters?.sku;
      if (
        !skuFilter ||
        skuFilter.value === null ||
        skuFilter.value === undefined ||
        skuFilter.value === 'undefined' ||
        skuFilter.value === ''
      ) {
        params.delete('search[sku][operator]');
        params.delete('search[sku][value]');
      }
      applyFixedGroupFilter(params);
      if (isLocked) {
        params.set('search[status][operator]', '=');
        params.set('search[status][value]', 'ACTIVE');
      }
      query = '?' + params.toString();
      // const fullUrl = process.env.REACT_APP_API_HOST + '/api/v2/material' + query;
      // console.log('VIEW:', view);
      // console.log('LAZYPARAMS:', lazyParams);
      // console.log('FINAL QUERY:', query);
      // console.log('FULL URL:', fullUrl);
      apiCall('get', '/api/v2/material' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setMaterials(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const applyFixedGroupFilter = (params) => {
    if (view !== 'master') {
      params.delete('search[material_group][operator]');
      params.delete('search[material_group][value]');
      [...params.keys()].forEach(k => {
        if (k.startsWith('search[material_group][value]')) params.delete(k);
      });
    }
    if (view === 'trading') {
      params.set('search[material_group][operator]', '=');
      params.set('search[material_group][value]', 'TG');
    }
    if (view === 'production') {
      params.set('search[material_group][operator]', 'in');
      ['RM', 'SFG', 'FG'].forEach(v => params.append('search[material_group][value][]', v));
    }
    if (view === 'operations') {
      params.set('search[material_group][operator]', 'in');
      ['MRO', 'Supply'].forEach(v => params.append('search[material_group][value][]', v));
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {canWrite &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'material') {
                      // history.push('/inventory/material/update/' + rowData.id)
                      history.push('/inventory/material/update/' + rowData.id + (history.location.search || ''));
                    }
                  }}/>
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  if(entity === 'material') {
                    history.push('/inventory/material/read/' + rowData.id)
                  }
                }}/>
        {canPrintLabels && (
          <Button
            icon="pi pi-print"
            className="p-button-secondary p-mr-2"
            tooltip={t('printLabel')}
            tooltipOptions={{position: 'left'}}
            onClick={() => setLabelPrintMaterial(rowData)}
          />
        )}
        {canWrite &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/material/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderMaterialList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  const applyContainsFilter = (params, filters, field) => {
    params.delete(`search[${field}]`);
    params.delete(`search[${field}][operator]`);
    params.delete(`search[${field}][value]`);
    const value = filters?.[field]?.value;
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      params.set(`search[${field}][operator]`, 'like');
      params.set(`search[${field}][value]`, String(value).trim());
    }
  };

  // const statusFilterElement = (
  //   <Dropdown
  //     value={lazyParams?.filters?.status?.value || 'ACTIVE'}
  //     options={statusOptions}
  //     onChange={(e) => {
  //       const _lazyParams = {...lazyParams};
  //       _lazyParams.filters = {
  //         ...(lazyParams.filters || {}),
  //         status: { value: e.value, matchMode: 'equals' }
  //       };
  //       _lazyParams.first = 0;
  //       _lazyParams.page = 0;
  //       setLazyParams(_lazyParams);
  //     }}
  //     placeholder={t('selectStatusPlaceholder')}//   />
  // );
  const statusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statusOptions}
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        placeholder={t('selectStatusPlaceholder')}style={{ minWidth: '100%' }}
        // disabled={window.App.urlVars().lock_status === '1'}
        disabled={isLocked}
      />
    );
  };

  const pickMaterial = (row) => {
    const p = new URLSearchParams(projectBacklink.split('?')[1] || '');
    const base = projectBacklink.split('?')[0];
    p.set('materialId', row.id);
    p.set('materialName', row.name);
    p.set('materialRowIndex', rowIndex);
    history.push(base + '?' + p.toString());
  };

  const materialGroupFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value || null}
        options={materialGroupOptions}
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        placeholder={t('selectGroupPlaceholder')}style={{ minWidth: '100%' }}
        showClear
      />
    );
  };

  const labelForMaterialGroup = (key) => {
    if (!key) return '';
    const hit = materialGroupOptions.find(opt => opt.value === key);
    return hit ? hit.label : key;
  };

  const categoryFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value || null}
        options={categoryOptions}
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        placeholder={props.t('selectCategoryPlaceholder')}
        style={{ minWidth: '100%' }}
        showClear
      />
    );
  };

  const unitFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value || null}
        options={unitOptions}
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        placeholder={t('selectUnitPlaceholder')}style={{ minWidth: '100%' }}
        showClear
      />
    );
  };

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/material-status')
      .then(response => {
        const data = response.data?.data || response.data || [];
        setStatusOptions(
          data.map(item => ({
            label: item.value,
            value: item.key,
          }))
        );
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    apiCall('get', '/api/v2/dictionary/material-group')
      .then(response => {
        const data = response.data?.data || response.data || [];
        setMaterialGroupOptions(
          data.map(item => ({
            label: item.value,
            value: item.key,
          }))
        );
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });

    apiCall('get', '/api/v2/material-category?limit=9999')
      .then(response => {
        const data = response.data?.data?.items || response.data?.data || response.data || [];
        setCategoryOptions(
          data.map(item => ({
            label: item.name,
            value: item.id,
          }))
        );
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    const unitUrl = view === 'trading' ? '/api/v2/unit?search[procurement][operator]==&search[procurement][value]=true'
        : (view === 'production' || view === 'operations') ? '/api/v2/unit?search[project][operator]==&search[project][value]=true' : '/api/v2/unit?limit=9999';
    apiCall('get', unitUrl)
      .then(response => {
        const data = response.data?.data?.items || response.data?.data || response.data || [];
        setUnitOptions(
          data.map(item => ({
            label: item.name,
            value: item.id,
          }))
        );
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [view]);

  useEffect(() => {
    localStorage.setItem(LIST_STORAGE_KEY, JSON.stringify({
      rows,
      lazyParams,
      sortField: lazyParams.sortField || DEFAULT_SORT_FIELD,
      sortOrder: typeof lazyParams.sortOrder === 'number' ? lazyParams.sortOrder : DEFAULT_SORT_ORDER,
    }));
  }, [rows, lazyParams, LIST_STORAGE_KEY]);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      rows: rows
    }));
  }, [rows]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, view, window.App.state.rerenderMaterialList])

  return (
    <>
    <style>
        {`
          .p-filter-locked .p-column-filter-clear-button {
            display: none !important;
          }
        `}
      </style>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={materials} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={lazyParams.rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 selectionMode={"single"}
                 onRowDoubleClick={(rowData) => {
                   if(window.App.urlVars().search === 'material' && entity === 'purchase-order') {
                     history.push('/procurement/' + entity + '/' + action + '/' + id + '?materialId=' + rowData.data.id + '&requestItemId=' + window.App.urlVars().requestItemId)
                   }
                   if (window.App.urlVars().search === 'material' && entity === 'project') {
                     pickMaterial(rowData.data)
                   }
                   if (window.App.urlVars().search === 'material' && entity === 'offer') {
                     pickMaterial(rowData.data)
                   }
                 }}
      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="unit.name" header={t('columnUnit2')} sortable filter filterField='unit' filterElement={unitFilterTemplate} body={(rowData) => {
          return (
            <>{rowData?.unit?.name}</>
          )
        }}></Column>
        <Column field="status" header={t('columnStatus2')} sortable filter showFilterClear={!isLocked} showFilterMenu={false} filterHeaderClassName={isLocked ? 'p-filter-locked' : ''} filterElement={statusFilterTemplate} body={(rowData) => {
          return(
            <>
              {rowData?.status === 'PHASE_OUT' &&
              <>Kifutó</>
              }
              {rowData?.status === 'ACTIVE' &&
              <>Aktív</>
              }
              {rowData?.status === 'OBSOLETE' &&
              <>Kivezetett</>
              }
            </>
          )
        }}></Column>

        {view === 'master' && (
          <Column field="material_group" header={t('columnGroup')} sortable filter filterElement={materialGroupFilterTemplate} body={(rowData) => (
            <>{labelForMaterialGroup(rowData?.material_group)}</>
          )}></Column>
        )}
          
        <Column field="manufacturer.name" header={t('columnManufacturer')} sortable filter filterField='manufacturer_name'></Column>

        
        {/* upc - gyártói */}
        {(view === 'trading' ||  view === 'master' || view === 'operations') && (
          <Column field="upc" header={t('upc')} sortable filter></Column>
        )}

        {(view === 'production' ||  view === 'master' || view === 'operations') && (
          <Column field="sku" header={t('sku')} sortable filter></Column>
        )}

        <Column field="category.name" header={t('columnCategory')} sortable filter filterField='category' filterElement={categoryFilterTemplate}></Column>
        {props.view !== 'search' &&
          <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        }
      </DataTable>
      {canPrintLabels && (
        <InventoryLabelPrintDialog
          visible={!!labelPrintMaterial}
          onHide={() => setLabelPrintMaterial(null)}
          materials={labelPrintMaterial ? [labelPrintMaterial] : []}
          source="material"
        />
      )}
    </>
  )
}
export default withTranslation('common')(MaterialListComponent);
